import axios from "../../config/axiosConfig";
import {
  CASH_BANK_REGISTER_REPORT_REQUEST,
  CASH_BANK_REGISTER_REPORT_SUCCESS,
  CASH_BANK_REGISTER_REPORT_FAILURE
} from "../types/cash-bank-report-types.js";

export const getCashBankRegisterReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CASH_BANK_REGISTER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };
      
      const defaultParams2 = {
        book_ids: params?.book_ids,
        filterType: params?.filterType, 
        selectedParties: params?.selectedParties, 
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      const requestParams = { ...defaultParams, ...defaultParams2 };
      const data = requestParams;


      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/bank-cash-register-report/getReport?${queryString}`;

      console.log('Complete API Request URL: ', fullUrl);

      return axios.post('/bank-cash-register-report/getReport', data, { params: defaultParams }).then((response) => {
        // Use the full URL directly
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: CASH_BANK_REGISTER_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Sales Register Report:", error);
        dispatch({ type: CASH_BANK_REGISTER_REPORT_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error("Error fetching Sales Register Report:", error);
      dispatch({ type: CASH_BANK_REGISTER_REPORT_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const clearBankCashRegisterReport = () => {
  return async (dispatch) => {
    dispatch({ type: CASH_BANK_REGISTER_REPORT_SUCCESS, payload: {} });
  }
}

